import React from 'react'

const SummaryPOHWizardData = ({comment,pohReason}:any) => {
    return (
        <div className='row'>
            <div className='col-md-12'>
                <h5 className='mb-2'>Summary</h5>
                <div className='d-flex '>
                    <p className='fw-500 w-25'>
                        Reason:
                    </p>
                    <p>{pohReason?.label}</p>
                </div>
                <div className='d-flex'>
                    <p className='fw-500 w-25'>
                        Comments:
                    </p>
                    <p>{comment}</p>
                </div>
            </div>
        </div>
    )
}

export default SummaryPOHWizardData